import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { TermsPage } from '../terms/terms';

import { ValidatorProvider } from '../../providers/validator/validator';
import { AlertProvider } from '../../providers/alert/alert';
import { NewRegistrationProvider } from '../../providers/new-registration/new-registration';

import { NewRegistration } from '../../models/newregistration';

/**
 * Generated class for the NewRegistrationStep3Page page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-new-registration-step3',
  templateUrl: 'new-registration-step3.html',
})
export class NewRegistrationStep3Page {

  public newRegistration: NewRegistration;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private validatorProvider: ValidatorProvider,
    private newRegistrationProvider: NewRegistrationProvider
  ) {
    this.newRegistration = new NewRegistration();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NewRegistrationStep3Page');
  }

  ionViewWillEnter() {
    let that = this;

    this.newRegistrationProvider.load().subscribe((data: any) => {
      if (data) {
        that.newRegistration = data;
      }
    }, (error: any) => {
      console.log(error);
    });
  }

  onBack() {
    this.newRegistrationProvider.saveDataAndGoToPage(this.newRegistration, -1);
  }

  goToTermsPage() {
    this.newRegistrationProvider.saveDataAndGoToPage(this.newRegistration, TermsPage);
  }

  doRegister() {
    console.log(this.newRegistration);

    if (this.validatorProvider.isEmpty(this.newRegistration.password)) {
      this.alertProvider.doAlert('Forneça sua nova senha.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.newRegistration.passwordCheck)) {
      this.alertProvider.doAlert('Forneça a confirmação da nova senha.', 'Atenção');
    } else if (this.newRegistration.password !== this.newRegistration.passwordCheck) {
      this.alertProvider.doAlert('A confirmação da nova senha não confere.', 'Atenção');
    } else {
      this.newRegistrationProvider.doRegister(this.newRegistration);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/new-registration-step3/new-registration-step3.ts